import type { Schema } from '../../../../../types/DirectusSchema';
import { removeUndefinedValues } from '../../../lib/removeUndefinedValues.ts';
import { parseFormValue } from '../../lib/parseFormValue.ts';
import type { FormData } from '../types/FormData.ts';
import { mapAdditionalDetailsToEventDetails } from './lib/mapAdditionalDetailsToEventDetails.ts';
import { mapTagsToTargetAudiences } from './lib/mapTagsToTargetAudiences.ts';
import { parseIsoDate } from './lib/parseIsoDate.ts';
import { parseOnlineLink } from './lib/parseOnlineLink.ts';
import { parseVenue } from './lib/parseVenue.ts';

export const formToApi = (updateData: Partial<FormData>): Partial<Schema['incomplete_events'][0]> => {
  const target_audiences = mapTagsToTargetAudiences(updateData.tags);
  const event_details = mapAdditionalDetailsToEventDetails(updateData.eventDetails);

  const data = {
    name: parseFormValue(updateData.name),
    category: updateData.category ? Number.parseInt(updateData.category, 10) : undefined,
    target_audiences,
    event_details,
    description: parseFormValue(updateData.description) ?? undefined,
    website_link: parseFormValue(updateData.websiteLink),
    instagram_link: parseFormValue(updateData.instagramLink),
    tiktok_link: parseFormValue(updateData.tiktokLink),
    type: parseFormValue(updateData.eventType),
    venue: parseVenue(updateData.eventType, updateData.venue ?? undefined),
    online_link: parseOnlineLink(updateData.eventType, updateData.onlineLink),
    image: parseFormValue(updateData.image),
    image_original: parseFormValue(updateData.image_original),
    image_crop_data: updateData.image_crop_data ?? null,
    spotify_link: parseFormValue(updateData.spotifyLink),
    start: parseIsoDate(updateData.start),
    end: parseIsoDate(updateData.end),
    recurrence_rate: parseFormValue(updateData.recurrenceRate),
    recurrence_active: parseFormValue(updateData.recurrenceActive),
    recurrence_amount: updateData.recurrenceAmount,
    recurrence_month_type: updateData.recurrenceMonthType,
    recurrence_duration_option: updateData.recurrenceDurationOption,
    ticket_sale_url: parseFormValue(updateData.ticketshopLink),
    custom_venue: parseFormValue(updateData.customVenue),
  };

  return removeUndefinedValues(data) as Partial<Schema['incomplete_events'][0]>;
};
